import React from "react";
import { Link } from "react-router-dom";
const CategoryCard = ({ categories }) => {
  const { _id, image, categoryName } = categories;
  return (
    <>
      <div className='box product'>
        <Link to={`/category/${_id}`}>
          <div className='nametop d_flex'>
            <span className='tleft'>{categoryName}</span>
          </div>
          <div className='img'>
            <img src={image} alt={categoryName}/>
          </div>
        </Link>
      </div>
    </>
  );
};

export default CategoryCard;
